$(document).ready(function () {
  var $body = $('body');
  var $applyNow = $('a.sw-btn--primary[href^="/about-us/apply-now/"]');
  var $askAQuestion = $('a.sw-btn--primary[href^="/about-us/ask-a-question/"]');
  var $searchNav = $('form.ga-search-nav');

  // home page
  if ($body.hasClass('page-type--homepage')) {
    $searchNav.each(function(){
      $(this).data('ga', true)
    }).on('submit', function() {
      gtag && gtag('event', 'Search (nav)', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      })
    });

    $('form#course-search').on('submit', function () {
      gtag && gtag('event', 'Search (page)', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      })
    });

    $('a.news-preview__featured-item-link, a.news-preview__item-link').on('click', function(){
      gtag && gtag('event', 'View news article', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

    $('a.story__link').on('click', function() {
      gtag && gtag('event', 'Read success story', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

    $('a.quicklinks__link').on('click', function() {
      gtag && gtag('event', 'Quicklinks', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

    $('a.campus-list__names-link').on('click', function() {
      gtag && gtag('event', 'Campuses', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

    $('a.explore-areas__link').on('click', function() {
      gtag && gtag('event', 'Course Area links', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

    $('a.featured-course__link').on('click', function() {
      gtag && gtag('event', 'Short course links', {
        event_category: 'Homepage',
        transport_type: 'beacon'
      });
    });

  }

  // homepage campaign
  if ($body.hasClass('page-type--homepage-campaign')) {
    $('a.hero-campaign__cta').on('click', function() {
      gtag && gtag('event', 'Primary call to action', {
        event_category: 'Homepage Campaign',
        transport_type: 'beacon'
      });
    });
  }

  // campaign detail page
  if ($body.hasClass('page-type--campaignpage')) {
    $('a.hero-campaign__cta').on('click', function() {
      gtag && gtag('event', 'Call To Action button', {
        event_category: 'Campaign Detail',
        transport_type: 'beacon'
      });
    });

    $('form').on('submit', function(){
      if($(this).valid()) {
        gtag && gtag('event', 'Successful form submit', {
          event_category: 'Campaign Detail',
          transport_type: 'beacon'
        });
      }
    })
  }

  // course areas
  if ($body.hasClass('page-type--courseslanding')) {
    $('form#course-search').on('submit', function () {
      gtag && gtag('event', 'Search', {
        event_category: 'Course Areas',
        transport_type: 'beacon'
      })
    });

    $('a.brick__link').on('click', function () {
      gtag && gtag('event', 'Select a course area', {
        event_category: 'Course Areas',
        transport_type: 'beacon'
      });
    })
  }

  // single course area
  if ($body.hasClass('page-type--coursearea')) {
    $applyNow.each(function(){
      $(this).data('ga', true)
    }).on('click', function(){
      gtag && gtag('event', 'Apply now', {
        event_category: 'Course Landing',
        transport_type: 'beacon'
      });
    });

    $askAQuestion.each(function(){
      $(this).data('ga', true)
    }).on('click', function(){
      gtag && gtag('event', 'Ask a question', {
        event_category: 'Course Landing',
        transport_type: 'beacon'
      });
    });
  }

  // course detail
  if ($body.hasClass('page-type--course')) {
    $applyNow.each(function(){
      $(this).data('ga', true)
    }).on('click', function(){
      gtag && gtag('event', 'Apply now', {
        event_category: 'Course Detail',
        transport_type: 'beacon'
      });
    });

    $askAQuestion.each(function(){
      $(this).data('ga', true)
    }).on('click', function(){
      gtag && gtag('event', 'Ask a question', {
        event_category: 'Course Detail',
        transport_type: 'beacon'
      });
    });

    $('a.course-pdf-button').on('click', function(){
      gtag && gtag('event', 'View Course PDF', {
        event_category: 'Course Detail',
        transport_type: 'beacon'
      });
    });
  }

  // global
  $applyNow.filter(function(){
    return !$(this).data('ga');
  }).on('click', function(){
    gtag && gtag('event', 'Apply now', {
      event_category: 'Global',
      transport_type: 'beacon'
    });
  });

  $askAQuestion.filter(function(){
    return !$(this).data('ga');
  }).on('click', function(){
    gtag && gtag('event', 'Ask a question', {
      event_category: 'Global',
      transport_type: 'beacon'
    });
  });

  $searchNav.filter(function(){
    return !$(this).data('ga')
  }).on('submit', function() {
    gtag && gtag('event', 'Search', {
      event_category: 'Global',
      transport_type: 'beacon'
    })
  });
});